var _mask, _path, _mask2, _path2, _mask3, _path3, _mask4, _path4, _mask5, _path5, _mask6, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValueRatingImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4001_14408",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.56741 87.9664C1.81394 78.5997 -0.426594 68.1509 0.0666319 57.6501C0.559857 47.1492 3.76981 36.9585 9.38015 28.0825C14.9905 19.2064 22.8075 11.9513 32.0609 7.03218C41.3143 2.11304 51.6847 -0.300346 62.1499 0.0298635C72.6152 0.360073 82.8141 3.42248 91.7416 8.91529C100.669 14.4081 108.017 22.1417 113.061 31.3539C118.105 40.5662 120.672 50.939 120.507 61.4503C120.343 71.9616 117.453 82.2484 112.123 91.297L91.3769 78.9782C94.5748 73.5491 96.3085 67.3769 96.4072 61.0702C96.5059 54.7634 94.9661 48.5397 91.9396 43.0124C88.9131 37.485 84.5044 32.8449 79.1479 29.5492C73.7914 26.2535 67.672 24.416 61.3928 24.2179C55.1137 24.0198 48.8915 25.4678 43.3394 28.4193C37.7874 31.3708 33.0972 35.7239 29.731 41.0495C26.3648 46.3751 24.4388 52.4895 24.1429 58.79C23.8469 65.0906 25.1912 71.3598 28.0433 76.9799L6.56741 87.9664Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56741 87.9664C1.81394 78.5997 -0.426594 68.1509 0.0666319 57.6501C0.559857 47.1492 3.76981 36.9585 9.38015 28.0825C14.9905 19.2064 22.8075 11.9513 32.0609 7.03218C41.3143 2.11304 51.6847 -0.300346 62.1499 0.0298635C72.6152 0.360073 82.8141 3.42248 91.7416 8.91529C100.669 14.4081 108.017 22.1417 113.061 31.3539C118.105 40.5662 120.672 50.939 120.507 61.4503C120.343 71.9616 117.453 82.2484 112.123 91.297L91.3769 78.9782C94.5748 73.5491 96.3085 67.3769 96.4072 61.0702C96.5059 54.7634 94.9661 48.5397 91.9396 43.0124C88.9131 37.485 84.5044 32.8449 79.1479 29.5492C73.7914 26.2535 67.672 24.416 61.3928 24.2179C55.1137 24.0198 48.8915 25.4678 43.3394 28.4193C37.7874 31.3708 33.0972 35.7239 29.731 41.0495C26.3648 46.3751 24.4388 52.4895 24.1429 58.79C23.8469 65.0906 25.1912 71.3598 28.0433 76.9799L6.56741 87.9664Z",
    fill: "url(#paint0_linear_4001_14408)",
    stroke: "#111111",
    strokeWidth: 1.9206,
    mask: "url(#path-1-inside-1_4001_14408)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_4001_14408",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.56741 87.9664C2.613 80.1742 0.38816 71.6139 0.0461944 62.8752C-0.295771 54.1366 1.25326 45.4273 4.58657 37.3477C7.91987 29.268 12.9582 22.0099 19.3544 16.0735C25.7506 10.1371 33.3526 5.66357 41.6366 2.96109C49.9206 0.258613 58.6897 -0.608543 67.3397 0.419369C75.9897 1.44728 84.3148 4.34582 91.7416 8.91528C99.1684 13.4847 105.52 19.6165 110.359 26.888C115.199 34.1595 118.41 42.398 119.773 51.0357L95.9666 54.8214C95.149 49.6388 93.2221 44.6957 90.3185 40.3328C87.415 35.9699 83.6039 32.2908 79.1479 29.5492C74.6918 26.8075 69.6967 25.0684 64.5067 24.4516C59.3167 23.8349 54.0553 24.3552 49.0849 25.9767C44.1144 27.5981 39.5532 30.2823 35.7155 33.8441C31.8778 37.4059 28.8548 41.7608 26.8548 46.6086C24.8548 51.4564 23.9254 56.6819 24.1306 61.9251C24.3358 67.1683 25.6707 72.3045 28.0433 76.9799L6.56741 87.9664Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56741 87.9664C2.613 80.1742 0.38816 71.6139 0.0461944 62.8752C-0.295771 54.1366 1.25326 45.4273 4.58657 37.3477C7.91987 29.268 12.9582 22.0099 19.3544 16.0735C25.7506 10.1371 33.3526 5.66357 41.6366 2.96109C49.9206 0.258613 58.6897 -0.608543 67.3397 0.419369C75.9897 1.44728 84.3148 4.34582 91.7416 8.91528C99.1684 13.4847 105.52 19.6165 110.359 26.888C115.199 34.1595 118.41 42.398 119.773 51.0357L95.9666 54.8214C95.149 49.6388 93.2221 44.6957 90.3185 40.3328C87.415 35.9699 83.6039 32.2908 79.1479 29.5492C74.6918 26.8075 69.6967 25.0684 64.5067 24.4516C59.3167 23.8349 54.0553 24.3552 49.0849 25.9767C44.1144 27.5981 39.5532 30.2823 35.7155 33.8441C31.8778 37.4059 28.8548 41.7608 26.8548 46.6086C24.8548 51.4564 23.9254 56.6819 24.1306 61.9251C24.3358 67.1683 25.6707 72.3045 28.0433 76.9799L6.56741 87.9664Z",
    fill: "url(#paint1_linear_4001_14408)",
    stroke: "#111111",
    strokeWidth: 1.9206,
    mask: "url(#path-2-inside-2_4001_14408)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_4001_14408",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.56741 87.9664C0.201486 75.4223 -1.6079 61.0419 1.45093 47.3023C4.50977 33.5628 12.2453 21.3245 23.325 12.6956C34.4046 4.06677 48.1347 -0.412354 62.1499 0.0298628C76.1651 0.47208 89.588 5.80795 100.106 15.1183L84.1666 33.271C77.8557 27.6848 69.802 24.4832 61.3928 24.2179C52.9837 23.9526 44.7457 26.6401 38.0979 31.8174C31.4501 36.9947 26.8087 44.3377 24.9734 52.5814C23.1381 60.8251 24.2238 69.4534 28.0433 76.9799L6.56741 87.9664Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56741 87.9664C0.201486 75.4223 -1.6079 61.0419 1.45093 47.3023C4.50977 33.5628 12.2453 21.3245 23.325 12.6956C34.4046 4.06677 48.1347 -0.412354 62.1499 0.0298628C76.1651 0.47208 89.588 5.80795 100.106 15.1183L84.1666 33.271C77.8557 27.6848 69.802 24.4832 61.3928 24.2179C52.9837 23.9526 44.7457 26.6401 38.0979 31.8174C31.4501 36.9947 26.8087 44.3377 24.9734 52.5814C23.1381 60.8251 24.2238 69.4534 28.0433 76.9799L6.56741 87.9664Z",
    fill: "url(#paint2_linear_4001_14408)",
    stroke: "#111111",
    strokeWidth: 1.9206,
    mask: "url(#path-3-inside-3_4001_14408)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_4001_14408",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.56741 87.9664C1.81394 78.5997 -0.426593 68.151 0.0666317 57.6501C0.559856 47.1492 3.76981 36.9585 9.38014 28.0825C14.9905 19.2064 22.8075 11.9513 32.0609 7.03219C41.3143 2.11305 51.6847 -0.300344 62.1499 0.029863L61.3928 24.2179C55.1137 24.0198 48.8915 25.4678 43.3394 28.4193C37.7874 31.3708 33.0972 35.7239 29.731 41.0495C26.3648 46.3751 24.4388 52.4895 24.1429 58.79C23.8469 65.0906 25.1912 71.3598 28.0433 76.9799L6.56741 87.9664Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56741 87.9664C1.81394 78.5997 -0.426593 68.151 0.0666317 57.6501C0.559856 47.1492 3.76981 36.9585 9.38014 28.0825C14.9905 19.2064 22.8075 11.9513 32.0609 7.03219C41.3143 2.11305 51.6847 -0.300344 62.1499 0.029863L61.3928 24.2179C55.1137 24.0198 48.8915 25.4678 43.3394 28.4193C37.7874 31.3708 33.0972 35.7239 29.731 41.0495C26.3648 46.3751 24.4388 52.4895 24.1429 58.79C23.8469 65.0906 25.1912 71.3598 28.0433 76.9799L6.56741 87.9664Z",
    fill: "url(#paint3_linear_4001_14408)",
    stroke: "#111111",
    strokeWidth: 1.9206,
    mask: "url(#path-4-inside-4_4001_14408)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-5_4001_14408",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.56741 87.9664C0.201485 75.4223 -1.6079 61.0419 1.45093 47.3023C4.50977 33.5628 12.2453 21.3245 23.325 12.6956L38.0979 31.8174C31.4501 36.9947 26.8087 44.3377 24.9734 52.5814C23.1381 60.8251 24.2238 69.4534 28.0433 76.9799L6.56741 87.9664Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56741 87.9664C0.201485 75.4223 -1.6079 61.0419 1.45093 47.3023C4.50977 33.5628 12.2453 21.3245 23.325 12.6956L38.0979 31.8174C31.4501 36.9947 26.8087 44.3377 24.9734 52.5814C23.1381 60.8251 24.2238 69.4534 28.0433 76.9799L6.56741 87.9664Z",
    fill: "url(#paint4_linear_4001_14408)",
    stroke: "#111111",
    strokeWidth: 1.9206,
    mask: "url(#path-5-inside-5_4001_14408)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-6_4001_14408",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.56741 87.9664C0.201487 75.4223 -1.6079 61.0419 1.45093 47.3023L24.9734 52.5814C23.1381 60.8251 24.2238 69.4534 28.0433 76.9799L6.56741 87.9664Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56741 87.9664C0.201487 75.4223 -1.6079 61.0419 1.45093 47.3023L24.9734 52.5814C23.1381 60.8251 24.2238 69.4534 28.0433 76.9799L6.56741 87.9664Z",
    fill: "url(#paint5_linear_4001_14408)",
    stroke: "#111111",
    strokeWidth: 1.9206,
    mask: "url(#path-6-inside-6_4001_14408)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91341 67.4648V62.6729H13.03V63.4006H10.7815V64.7015H12.8686V65.4292H10.7815V66.7372H13.0488V67.4648H9.91341Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9483 38.4258H16.3245V33.6339H17.981C18.4568 33.6339 18.8655 33.7298 19.2071 33.9216C19.5503 34.112 19.8139 34.3857 19.998 34.7429C20.182 35.1001 20.2741 35.5275 20.2741 36.0251C20.2741 36.5243 20.1813 36.9533 19.9956 37.312C19.8116 37.6708 19.5456 37.9461 19.1978 38.138C18.8515 38.3298 18.435 38.4258 17.9483 38.4258ZM17.1925 37.6747H17.9062C18.24 37.6747 18.5184 37.6139 18.7415 37.4922C18.9645 37.369 19.1322 37.1857 19.2445 36.9423C19.3569 36.6974 19.413 36.3917 19.413 36.0251C19.413 35.6586 19.3569 35.3544 19.2445 35.1126C19.1322 34.8693 18.9661 34.6875 18.7462 34.5674C18.5278 34.4458 18.2564 34.3849 17.9319 34.3849H17.1925V37.6747Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5904 12.7272H46.7153C46.6903 12.5837 46.6443 12.4566 46.5772 12.3458C46.5102 12.2335 46.4267 12.1384 46.3269 12.0604C46.227 11.9824 46.1132 11.9239 45.9853 11.8849C45.8589 11.8443 45.7224 11.8241 45.5758 11.8241C45.3153 11.8241 45.0844 11.8896 44.8832 12.0206C44.682 12.1501 44.5244 12.3404 44.4106 12.5915C44.2967 12.8411 44.2398 13.146 44.2398 13.5064C44.2398 13.8729 44.2967 14.1818 44.4106 14.4329C44.526 14.6825 44.6835 14.8713 44.8832 14.9992C45.0844 15.1255 45.3145 15.1887 45.5734 15.1887C45.717 15.1887 45.8511 15.17 45.9759 15.1325C46.1022 15.0935 46.2153 15.0366 46.3152 14.9617C46.4166 14.8869 46.5016 14.7948 46.5702 14.6856C46.6404 14.5765 46.6888 14.4517 46.7153 14.3113L47.5904 14.316C47.5576 14.5437 47.4866 14.7574 47.3774 14.9571C47.2698 15.1567 47.1286 15.333 46.9539 15.4859C46.7792 15.6372 46.5749 15.7557 46.3409 15.8415C46.1069 15.9257 45.8472 15.9679 45.5618 15.9679C45.1406 15.9679 44.7647 15.8704 44.434 15.6754C44.1033 15.4804 43.8428 15.1988 43.6525 14.8307C43.4622 14.4626 43.367 14.0211 43.367 13.5064C43.367 12.9901 43.4629 12.5486 43.6548 12.182C43.8467 11.8139 44.1079 11.5324 44.4386 11.3374C44.7693 11.1424 45.1437 11.0449 45.5618 11.0449C45.8285 11.0449 46.0765 11.0823 46.3058 11.1572C46.5351 11.2321 46.7395 11.3421 46.9188 11.4871C47.0982 11.6306 47.2456 11.8069 47.3611 12.0159C47.4781 12.2234 47.5545 12.4605 47.5904 12.7272Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9566 17.5508V12.7589H77.791C78.1373 12.7589 78.4251 12.8134 78.6544 12.9226C78.8853 13.0303 79.0576 13.1777 79.1715 13.3649C79.2869 13.552 79.3447 13.7642 79.3447 14.0013C79.3447 14.1963 79.3072 14.3632 79.2323 14.502C79.1575 14.6393 79.0569 14.7508 78.9305 14.8366C78.8042 14.9224 78.663 14.984 78.507 15.0214V15.0682C78.677 15.0776 78.84 15.1299 78.996 15.225C79.1536 15.3186 79.2823 15.4512 79.3821 15.6228C79.4819 15.7944 79.5318 16.0018 79.5318 16.2452C79.5318 16.4932 79.4718 16.7162 79.3517 16.9144C79.2316 17.1109 79.0506 17.2661 78.8088 17.38C78.5671 17.4938 78.2629 17.5508 77.8963 17.5508H75.9566ZM76.8247 16.8254H77.7583C78.0734 16.8254 78.3003 16.7654 78.4391 16.6453C78.5795 16.5236 78.6497 16.3676 78.6497 16.1773C78.6497 16.0354 78.6146 15.9075 78.5444 15.7936C78.4742 15.6782 78.3744 15.5877 78.2449 15.5222C78.1155 15.4551 77.961 15.4216 77.7817 15.4216H76.8247V16.8254ZM76.8247 14.7968H77.6834C77.8331 14.7968 77.9681 14.7695 78.0882 14.7149C78.2083 14.6588 78.3027 14.58 78.3713 14.4786C78.4415 14.3757 78.4766 14.254 78.4766 14.1136C78.4766 13.928 78.4111 13.7751 78.28 13.655C78.1506 13.5349 77.9579 13.4748 77.7021 13.4748H76.8247V14.7968Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.285 40.6602H99.3585L101.046 35.8682H102.117L103.807 40.6602H102.88L101.6 36.8509H101.563L100.285 40.6602ZM100.316 38.7813H102.843V39.4786H100.316V38.7813Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103.249 69.7227H102.438L103.914 65.5323H104.851L106.328 69.7227H105.518L104.399 66.3916H104.366L103.249 69.7227ZM103.275 68.0796H105.485V68.6894H103.275V68.0796ZM107.565 69.0515V66.2198H108.207V69.0515H107.565ZM106.47 67.9569V67.3144H109.302V67.9569H106.47ZM110.923 69.0515V66.2198H111.565V69.0515H110.923ZM109.828 67.9569V67.3144H112.66V67.9569H109.828Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4001_14408",
    x1: 108.999,
    y1: 38.281,
    x2: 18.4792,
    y2: 45.7828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18D842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.260417,
    stopColor: "#FFE81E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FF6F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE3838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4001_14408",
    x1: 108.999,
    y1: 38.281,
    x2: 18.4792,
    y2: 45.7828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18D842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.260417,
    stopColor: "#FFE81E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FF6F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE3838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4001_14408",
    x1: 108.999,
    y1: 38.281,
    x2: 18.4792,
    y2: 45.7828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18D842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.260417,
    stopColor: "#FFE81E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FF6F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE3838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4001_14408",
    x1: 108.999,
    y1: 38.281,
    x2: 18.4792,
    y2: 45.7828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18D842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.260417,
    stopColor: "#FFE81E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FF6F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE3838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4001_14408",
    x1: 108.999,
    y1: 38.281,
    x2: 18.4792,
    y2: 45.7828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18D842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.260417,
    stopColor: "#FFE81E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FF6F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE3838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4001_14408",
    x1: 108.999,
    y1: 38.281,
    x2: 18.4792,
    y2: 45.7828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18D842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.260417,
    stopColor: "#FFE81E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FF6F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE3838"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueRatingImg);
export default __webpack_public_path__ + "static/media/value_rating_img.406fa717af368078f761a0fe13836268.svg";
export { ForwardRef as ReactComponent };